import IconEmpty from '@bimser/icons/16/empty-icon';
import GetIcon16ByName from '@bimser/icons/lib/getIcon16ByName';
import { Collapse } from 'antd';
import React, { JSX } from 'react';
import BCAddonButton from '../BCAddonButton';
import { IButtonBarItem } from '../BCButtonBar/entities';
import { findMessage } from '../BCIntl';
import BCScrollbars from '../BCScrollbars';
import Styles from './assets/styles.scss';
import { ICollapseItem, ICollapseProps, ICollapseToolboxItem } from './entities';
import { ICollapsePanelProps } from './entities/ICollapseProps';
import IconCollapse from '@bimser/icons/16/collapse';
import IconExpand from '@bimser/icons/16/expand';

const BCCollapse = (props: ICollapseProps) => {
	Styles;

	const [activeKey, setactiveKey] = React.useState<string | string[]>(null);

	const onChange = (activeKey: string | string[]) => {
		if (props.onChangeExpandedKeys) {
			props.onChangeExpandedKeys(activeKey);
		} else {
			setactiveKey(activeKey);
		}
	};

	const wrapperWithScrollbars = (children: JSX.Element) => (
		<>
			{renderToolboxHeader()}
			<BCScrollbars styles={props.scrollbarStyles}>{children}</BCScrollbars>
		</>
	);

	const toolboxItemClick = (args: string) => {
		props.onToolboxItemClick?.(args);
	};

	const renderToolboxHeader = () => {
		if (props.toolboxItems?.length) {
			const toolboxItems = props.toolboxItems;
			const items: IButtonBarItem[] = [];
			const farItems: IButtonBarItem[] = [];

			toolboxItems.forEach(toolbox => {
				const Icon = GetIcon16ByName(toolbox.icon, IconEmpty);
				if (toolbox.farItem) {
					farItems.push({
						buttonProps: {
							text: toolbox.text,
							title: toolbox.text,
							id: toolbox.key,
							icon: <Icon />,
							onClick: () => toolboxItemClick(toolbox.key)
						},
						externalData: {
							showText: toolbox.showText
						}
					});
				} else {
					items.push({
						buttonProps: {
							text: toolbox.text,
							title: toolbox.text,
							id: toolbox.key,
							icon: <Icon />,
							className: toolbox.active ? 'active' : '',
							onClick: () => toolboxItemClick(toolbox.key)
						},
						externalData: {
							showText: toolbox.showText
						}
					});
				}
			});

			return (
				<BCAddonButton
					items={items}
					farItems={farItems}
					elementsCountToShow={5}
				>
					<span>{findMessage.get('100896')}</span>
				</BCAddonButton>
			);
		}
	};

	const expandIcon = ({ isActive }) => {
		if (props.hideArrow) {
			return null;
		}
		if (props.expandIcon) {
			return props.expandIcon(isActive);
		}
		return isActive ? (
			<IconCollapse className="collapseBtn" />
		) : (
			<IconExpand className="expandBtn" />
		);
	};

	const renderCollapse = () => {
		const { items, classNames, containerStyles } = props;

		const manageCollapseKeyProps = {
			activeKey: props.expandedKeys ? props.expandedKeys : activeKey
		};

		return (
			<>
				{!props.hasScrollbar && renderToolboxHeader()}
				<Collapse
					bordered={false}
					defaultActiveKey={props.defaultActiveKey}
					className={classNames && classNames.length ? classNames.join(' ') : undefined}
					style={{ ...containerStyles }}
					accordion={props.accordion}
					expandIcon={expandIcon}
					{...(props.manageStateBySelf ? {} : manageCollapseKeyProps)}
					onChange={onChange}
					items={items}
					expandIconPosition={props.expandIconPosition || 'end'}
				/>
			</>
		);
	};

	if (props.hasScrollbar) {
		return wrapperWithScrollbars(renderCollapse());
	} else {
		return renderCollapse();
	}
};

export default BCCollapse;
export { ICollapseItem, ICollapsePanelProps, ICollapseProps, ICollapseToolboxItem };
